<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4"><a id="file_014"><em>MAKING ENDS MEET</em></a></h4><a id="file_014">
<p class="noindent">Grumman Aircraft began operations on January 2, 1930. It was terrible timing. The Wall Street stock market crash had occurred a little over two months before. No one, it seemed, could afford the new airplanes that Leroy Grumman was hoping to build.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_014.vue?2481376a